import Vue from "vue";

export type Nullable<T> = T | null | undefined;

export type VForm = Vue & {
  validate: () => boolean;
  resetValidation: () => boolean;
  reset: () => void;
};

export type UrlQuery = Record<string, string | (string | null)[] | null | undefined>;

export type TableOptions = {
  page: number;
  itemsPerPage: number;
  sortBy: Array<string>;
  sortDesc: Array<boolean>;
  groupBy: Array<string>;
  groupDesc: Array<boolean>;
  multiSort: boolean;
  mustSort: false;
};

export enum Separator {
  Comma = "",
  Dot = ".",
  NormalSpace = " ",
  ThinSpace = '\u2009',
  NarrowNoBreakSpace = '\u202f',
  NoBrakeSpace = '\u00a0',
  NoSeparator = "",
  Apostrophe = "'",
  ArabicThousandsSeparator = "٬",
  DotAbove = "˙"
}

// ze slowkiem type, bo inaczej sa problemy z rozroznieniem czy chodzi o komponent czy typ
export type ConfirmationDialogType = Vue & {
  open: (title: string, message: string, options: Record<string, unknown>) => Promise<boolean>;
  close: () => void;
};
